function getHeadData(property) {
  if (document.querySelector(`meta[property="${property}"]`)) {
    return document.querySelector(`meta[property="${property}"]`).getAttribute('content');
  }
  return;
}

const shareContent = () => {
  if (navigator.share) {
    navigator.share({
      title: 'test',
      text: 'text',
      url: 'https://www.google.com'
    })
  }
}

if ('undefined' === typeof window.Share) {
  window.Share = shareContent;
}